import { openBlock as a, createElementBlock as e, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}, t = /* @__PURE__ */ l("path", {
  fill: "currentColor",
  d: "M2.504 6.567a.623.623 0 0 1-.884 0L.183 5.129a.625.625 0 1 1 .884-.884l.277.277 1.408-1.409-1.858-.858a.625.625 0 0 1 .379-1.182l2.956.563.954-.953a.625.625 0 1 1 .884.884l-.954.953.563 2.957a.625.625 0 0 1-1.181.379l-.859-1.859-1.409 1.409.277.277a.625.625 0 0 1 0 .884m12.429 6.187a.623.623 0 0 0 .884 0 .625.625 0 0 0 0-.884l-1.438-1.437a.625.625 0 0 0-.884.884l.277.277-1.409 1.408-.858-1.858a.625.625 0 0 0-1.182.379l.563 2.956-.953.954a.625.625 0 1 0 .884.884l.953-.954 2.957.563a.63.63 0 0 0 .712-.423.625.625 0 0 0-.333-.758l-1.859-.859 1.409-1.409zm-6.415.998a11.3 11.3 0 0 1-5.297 1.341.625.625 0 1 0 0 1.25c2.024 0 4.06-.514 5.885-1.488a.625.625 0 0 0-.588-1.103M13.931 9.1a.623.623 0 0 0 .826-.313 12.4 12.4 0 0 0 1.087-5.132.625.625 0 1 0-1.25 0c0 1.626-.329 3.18-.977 4.618a.625.625 0 0 0 .314.827M7.28 3.305a.6.6 0 0 0 .293-.073c1.658-.88 3.42-1.326 5.238-1.326a.625.625 0 1 0 0-1.25c-2.023 0-3.983.495-5.824 1.471a.625.625 0 0 0 .294 1.178ZM2.097 7.899a.625.625 0 0 0-.826.313 12.4 12.4 0 0 0-1.08 5.132.625.625 0 1 0 1.25 0c0-1.635.326-3.189.97-4.619a.625.625 0 0 0-.314-.826M16 1.281a.781.781 0 1 1-1.562 0 .781.781 0 0 1 1.562 0M.815 14.937a.781.781 0 1 0 0 1.563.781.781 0 0 0 0-1.563"
}, null, -1), c = [
  t
];
function n(r, s) {
  return a(), e("svg", o, [...c]);
}
const i = { render: n };
export {
  i as default,
  n as render
};
